import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TimesheetService {
  private apiUrl      = environment.apiUrl + '/api/timesheets';
  private exportUrl   = environment.apiUrl + '/api/timesheets/export-spreadsheet';
  private taAdminUrl  = environment.apiUrl + '/api/ta-admin/timesheets';

  constructor(private http: HttpClient) {}

  // ── Existing timesheet (Google Sheets flow) ───────────
  getTimesheets(params?: any): Observable<any> {
    return this.http.get<any>(this.apiUrl, { params });
  }

  getMissingTimesheets(params?: any): Observable<any> {
    return this.http.get<any>(this.apiUrl + '/missing', { params });
  }

  exportSpreadsheet(params?: any): Observable<Blob> {
    return this.http.get(this.exportUrl, { params, responseType: 'blob' });
  }

  exportMissingTimesheets(params?: any): Observable<Blob> {
    const url = environment.apiUrl + '/api/export/missing-timesheets';
    return this.http.get(url, { params, responseType: 'blob' });
  }

  exportWise(params?: any): Observable<Blob> {
    const url = environment.apiUrl + '/api/export/wise';
    return this.http.get(url, { params, responseType: 'blob' });
  }

  // ── TA Portal timesheets (HRS admin) ──────────────────
  getTaTimesheets(params?: any): Observable<any> {
    return this.http.get<any>(this.taAdminUrl, { params });
  }

  approveTaTimesheet(id: number): Observable<any> {
    return this.http.put<any>(`${this.taAdminUrl}/${id}/approve`, {});
  }

  unlockTaTimesheet(id: number, reason: string): Observable<any> {
    return this.http.put<any>(`${this.taAdminUrl}/${id}/unlock`, { reason });
  }

  getTaTimesheetStats(params?: any): Observable<any> {
    return this.http.get<any>(`${this.taAdminUrl}/stats`, { params });
  }

  sendBulkNotification(params: { pay_period_year: number; pay_period_month: number; pay_period?: string }): Observable<any> {
    return this.http.post<any>(`${this.taAdminUrl}/bulk-notify`, params);
  }

  getBulkSchedules(): Observable<any[]> {
    return this.http.get<any[]>(environment.apiUrl + '/api/ta-bulk-schedules');
  }

  updateBulkSchedule(id: number, data: any): Observable<any> {
    return this.http.put<any>(environment.apiUrl + `/api/ta-bulk-schedules/${id}`, data);
  }
}
